<template>
  <page layout="tabbed">
    <page-header-new title="Page With Tabs"></page-header-new>
    <page-tabs :tabs="tabs"></page-tabs>
  </page>
</template>

<script>
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import Page from '@/common/components/page/Page'

export default {
  components: { Page, PageTabs, PageHeaderNew },

  data() {
    return {
      tabs: [
        {
          title: 'Tab 1',
          route: {
            name: 'VueTestsTabbedPageTabOne'
          }
        },
        {
          title: 'Tab 2',
          route: {
            name: 'VueTestsTabbedPageTabTwo'
          }
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/tests/page/TabbedPage.vue